import { MultiSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventFormat } from "../types/eventFormat";

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const EventFormatMultiSelectField: FC<Props> = (props) => {
	const { t } = useTranslation();
	return (
		<MultiSelectField
			{...props}
			options={[
				{ name: t(EventFormat.ONLINE), value: EventFormat.ONLINE },
				{ name: t(EventFormat.ONSITE), value: EventFormat.ONSITE },
				{ name: t(EventFormat.HYBRID), value: EventFormat.HYBRID },
			]}
			getValue={(o) => o.value}
		/>
	);
};
